export const LIST_STATE = 'LIST_STATE';
export const LIST_CITY = 'LIST_CITY';
export const LIST_DISTRICT = 'LIST_DISCTRICT';
export const LIST_GALLERY = 'LIST_GALLERY';
